import CitySEOHead from "@/components/feature/CitySEOHead";
import MSHeroSection from "./components/HeroSection";
import MSCitiesDirectory from "./components/CitiesDirectory";
import MSStateResources from "./components/StateResources";
import MSFAQSection, { faqs } from "./components/FAQSection";
import MSFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const services = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

const mappedFaqs = faqs.map((f) => ({ q: f.question, a: f.answer }));

export default function MississippiPage() {
  return (
    <>
      <CitySEOHead
        city="Mississippi"
        state="Mississippi"
        stateAbbr="MS"
        route="/states/mississippi"
        title="Mississippi Passport Services — Expedited & Emergency | Fast Passport Center"
        description="Expedited passport services across Mississippi — Jackson, Gulfport, Southaven, Hattiesburg, Biloxi, and Meridian. Emergency processing as fast as 24 hours. A+ BBB rated courier service."
        geoPlacename="Mississippi, United States"
        geoPosition="32.7540;-89.2318"
        faqs={mappedFaqs}
        servicesSchema={services}
      />
      <div className="font-sans">
        <MSHeroSection />
        <MSCitiesDirectory />
        <MSStateResources />
        <MSFAQSection />
        <SEOCrossLinks state="MS" />
        <MSFinalCTA />
      </div>
    </>
  );
}